<script lang="ts" setup>
import { useAuthStore } from '#modules/auth/store/auth';
import { storeToRefs } from 'pinia';
import logoutIcon from '../assets/img/nav/ic-logout.svg';
import type { SidebarMenu } from '../types/SidebarMenu';
import { AUTH_ROUTES, GUEST_ROUTES } from '../utils/constants/Menu';

interface Props {
  prependMenu?: SidebarMenu[];
  appendMenu?: SidebarMenu[];
}
const { prependMenu = [], appendMenu = [] } = defineProps<Props>();

const { user } = storeToRefs(useAuthStore());

const navigations = computed((): SidebarMenu[] => {
  const menus = [];

  const authRoutes = [
    ...AUTH_ROUTES,
    {
      title: 'Logout',
      icon: logoutIcon,
      action: handleLogout,
    },
  ];
  const guesRoutes = [...GUEST_ROUTES];

  if (user.value && Object.keys(user.value).length) {
    menus.push(...authRoutes);
  } else {
    menus.push(...guesRoutes);
  }

  return [...prependMenu, ...menus, ...appendMenu];
});

const { signOut } = useAuth();
const { unregisterDevice } = useDevice();
const handleLogout = async () => {
  await unregisterDevice();
  await signOut({ callbackUrl: '/login' });
};
</script>
<template>
  <v-list rounded="100" class="pa-0 text-subtitle-2">
    <template v-for="(navigation, index) in navigations" :key="index">
      <v-list-item
        :data-cy="`menu-${navigation.link?.name}`"
        class="px-4 py-2"
        :to="navigation.link || undefined"
        @click="navigation.action ? navigation.action() : null"
      >
        <template v-if="navigation.icon" #prepend>
          <v-icon v-if="navigation.mdi"> {{ navigation.icon }}</v-icon>
          <v-img v-else :src="navigation.icon" width="20px" height="20px" class="mr-4"></v-img>
        </template>
        <v-list-item-title :class="{ 'ml-10': !navigation.icon }">
          <span class="text-subtitle-2">
            {{ navigation.title }}
          </span>
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-list>
</template>
<style lang="scss" scoped>
.navbar-menu {
}
</style>
